import PropTypes from 'prop-types';
import React from 'react';
import useSheet from 'app/jss';

const propTypes = {
  children: PropTypes.node,
  sheet: PropTypes.object.isRequired,
};

const defaultProps = {
  children: undefined,
};

function RowSuffix({ children, sheet: { classes } }) {
  return <div className={classes.outer}>{children}</div>;
}

RowSuffix.propTypes = propTypes;
RowSuffix.defaultProps = defaultProps;

function applyStyles() {
  return {
    outer: {
      display: 'flex',
      minHeight: 50,
    },
  };
}

export default useSheet(applyStyles)(RowSuffix);
